export default "__VITE_ASSET__CR7nA1hx__"